import { call, put, takeEvery } from 'redux-saga/effects'
import { postGetAllCompany, postLoginEmail, postLoginPassword, postLoginVerifictioncode, postRegisterEmail, postRegisterVerifictionCode, postLogin, addCompanyRequest, forgotPassword, getSessionId } from '../apiRequests/userRequests'
import { types } from '../../types'

function* handlePostLoginEmail(action) {
  try {

    const response = yield call(postLoginEmail, action.params)

    yield put({
      type: types.LOGIN_REQUEST_SUCCESS,
      action: response,
    })
  } catch (error) {

    yield put({
      type: types.LOGIN_REQUEST_ERROR,
      action: error,
    })
  }
}

function* handlePostLoginVerifictionCode(action) {
  try {
    const response = yield call(postLoginVerifictioncode, action.params)
    yield put({
      type: types.SEND_VERIFICTION_SUCCESS,
      action: response,
    })
  } catch (error) {
    yield put({
      type: types.SEND_VERIFICTION_ERROR,
      error: error.response,
    })
  }
}

function* handlePostRegisterVerifictionCode(action) {

  try {

    const response = yield call(postRegisterVerifictionCode, action.params)

    yield put({
      type: types.REGISTER_SEND_VERIFICTION_SUCCESS,
      action: response,
    })
  } catch (error) {

    yield put({
      type: types.REGISTER_SEND_VERIFICTION_ERROR,
      error: error.response,
    })
  }
}

function* handlePostLoginPassword(action) {
  try {
    const response = yield call(postLoginPassword, action.params)
    yield put({
      type: types.SEND_PASSWORD_SUCCESS,
      action: response,
    })
  } catch (error) {
    yield put({
      type: types.SEND_PASSWORD_ERROR,
      error: error.response,
    })
  }
}



function* handlePostRegisterEmail(action) {
  try {
    const response = yield call(postRegisterEmail, action.params)
    yield put({
      type: types.REGISTER_REQUEST_SUCCESS,
      action: response,
    })
  } catch (error) {
    yield put({
      type: types.REGISTER_REQUEST_ERROR,
      error: error.response,
    })
  }
}

function* handlePostGetAllCompany(action) {
  try {

    const response = yield call(postGetAllCompany, action.params)

    yield put({
      type: types.GET_ALL_COMPANY_SUCCESS,
      action: response,
    })
  } catch (error) {
    yield put({
      type: types.GET_ALL_COMPANY_ERROR,
      error: error.response,
    })
  }
}

function* handlePostLogin(action) {
  try {

    const response = yield call(postLogin, action.params)

    yield put({
      type: types.LOGIN_PASSWORD_REQUEST_SUCCESS,
      action: response,
    })
  } catch (error) {
    yield put({
      type: types.LOGIN_PASSWORD_REQUEST_ERROR,
      error: error.response,
    })
  }
}


function* handleAddCompany(action) {
  try {
    const response = yield call(addCompanyRequest, action.params)

    yield put({
      type: types.ADD_COMPANY_SUCCESS,
      action: response,
    })
  } catch (error) {
    yield put({
      type: types.ADD_COMPANY_ERROR,
      error: error?.response,
    })
  }
}


function* handleForgotPassword(action) {
  try {
    const response = yield call(forgotPassword, action.params)
    yield put({
      type: types.FORGOT_PASSWORD_SUCCESS,
      action: response,
    })
  } catch (error) {
    yield put({
      type: types.FORGOT_PASSWORD_ERROR,
      error: error?.response,
    })
  }
}


// function* handleGetSessionId(action) {
//   try {
//     const response = yield call(getSessionId)
//     yield put({
//       type: types.GET_SESSION_ID_SUCCESS,
//       action: response,
//     })
//   } catch (error) {
//     yield put({
//       type: types.GET_SESSION_ID_ERROR,
//       error: error?.response,
//     })
//   }
// }



function* watcherUserSaga() {
  yield takeEvery(types.LOGIN_REQUEST, handlePostLoginEmail)
  yield takeEvery(types.SEND_VERIFICTION_REQUEST, handlePostLoginVerifictionCode)
  yield takeEvery(types.SEND_PASSWORD_REQUEST, handlePostLoginPassword)
  yield takeEvery(types.REGISTER_REQUEST, handlePostRegisterEmail)
  yield takeEvery(types.GET_ALL_COMPANY_REQUEST, handlePostGetAllCompany)
  yield takeEvery(types.REGISTER_SEND_VERIFICTION_REQUEST, handlePostRegisterVerifictionCode)
  yield takeEvery(types.LOGIN_PASSWORD_REQUEST, handlePostLogin)
  yield takeEvery(types.FORGOT_PASSWORD_REQUEST, handleForgotPassword)
  yield takeEvery(types.ADD_COMPANY_REQUEST, handleAddCompany)
  // yield takeEvery(types.GET_SESSION_ID_REQUEST, handleGetSessionId)

}

export default watcherUserSaga
